/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Err_Fee_ReasonInputs */

const vi_sales_return_err_fee_reason = /** @type {(inputs: Sales_Return_Err_Fee_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập lý do thu phí trả hàng`)
};

/**

* @param {Sales_Return_Err_Fee_ReasonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_err_fee_reason = /** @type {((inputs?: Sales_Return_Err_Fee_ReasonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Err_Fee_ReasonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_err_fee_reason(inputs)
});